import { ref } from 'vue'
import { TenantPackagesApi } from '../services/packages'
import { useUserStore } from '../stores/user'

export function useTenantWarning() {
  const showModal = ref(false)
  const message = ref('')
  const onceKey = ref<string | null>(null)
  const user = useUserStore()

  const todayKey = () => new Date().toISOString().slice(0, 10)

  async function check() {
    const { data } = await TenantPackagesApi.warning()

    if (data.expired) {
      if (user.isTenantAdmin) {
        message.value = 'Paketiniz sona ermiştir. Lütfen Hesabım sayfasından paketinizi yenileyiniz.'
        showModal.value = true
        onceKey.value = null // Expired warning should always show if possible
      }
      return
    }

    if (!data.show || !data.onceKey) return

    const localKey = `pkgWarn:${data.onceKey}`
    const stored = localStorage.getItem(localKey)
    if (stored === todayKey()) return

    onceKey.value = localKey
    message.value = `Paketiniz ${data.daysLeft} gün sonra (${new Date(data.endAtUtc!).toLocaleDateString(
      'tr-TR',
    )}) sona erecek. Lütfen yenilemeyi unutmayın.`
    showModal.value = true
  }

  function markSeen() {
    if (onceKey.value) {
      localStorage.setItem(onceKey.value, todayKey())
    }
    showModal.value = false
  }

  return { showModal, message, check, markSeen }
}
